<template>
    <div :class="['flex items-center gap-3', className]">
        <slot name="prev" :value="inputValue" :checked="enabled"></slot>
        <vue-switch
            :color="color"
            :type-bold="true"
            :value="enabled"
            @input="enabled = $event"
            :disabled="disabled"
        />
        <slot name="next" :value="inputValue" :checked="enabled"></slot>
        <div style="display: none">
            <slot name="hidden" :value="inputValue" :checked="enabled"></slot>
        </div>
    </div>
</template>

<script>
import Switches from "./widget/Switches.vue";
import mixinInput from "./mixinInput.vue";
import mixinCommon from "./mixinCommon.vue";

export default {
    mixins: [mixinInput, mixinCommon],
    components: {
        "vue-switch": Switches,
    },
    props: {
        name: {
            type: String,
            default: "",
        },
        className: {
            type: String,
            default: "",
        },
        color: {
            type: String,
            default: "primary",
        },
        disabled: {
            type: [Boolean, String, Number],
            default: false,
        },
        checkedValue: {
            type: [String, Number],
            default: 1,
        },
        uncheckedValue: {
            type: [String, Number],
            default: 0,
        },
    },
    computed: {
        enabled: {
            get() {
                return typeof this.inputValue === "string"
                    ? !!+this.inputValue.trim()
                    : !!+this.inputValue;
            },
            set(enabled) {
                this.inputValue = enabled ? "1" : "";
                this.$emit("input", this.inputValue);
            },
        },
    },
};
</script>
